import { Controller } from '@hotwired/stimulus'

/* This is your ApplicationController.
 * All StimulusReflex controllers should inherit from this class.
 *
 * Example:
 *
 *   import ApplicationController from './application_controller'
 *
 *   export default class extends ApplicationController { ... }
 *
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends Controller {
    log (message, ...args) {
        this.application.logFormattedMessage(this.identifier, message, ...args);
    }
}

